import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { MdSearch } from 'react-icons/md';
import { useTheme } from '@mui/material/styles';

/**
 * Reusable Search Field Component
 * 
 * @param {String} searchQuery - Current search value
 * @param {Function} handleSearchChange - Callback when search changes (receives string value)
 * @param {String} placeholder - Placeholder text (default: "Search...")
 * @param {Object} sx - Additional styles
 */
const SearchField = ({ 
    searchQuery = '', 
    handleSearchChange = () => {}, 
    placeholder = "Search...",
    sx = {}
}) => {
    const theme = useTheme();

    // ✅ Handle change and pass value directly
    const onChange = (event) => {
        handleSearchChange(event.target.value);
    };

    return (
        <TextField
            fullWidth
            placeholder={placeholder}
            value={searchQuery}
            onChange={onChange}
            sx={{
                '& .MuiOutlinedInput-root': {
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 2,
                    '& fieldset': {
                        borderColor: 'rgba(255, 255, 255, 0.1)',
                    },
                    '&:hover fieldset': {
                        borderColor: theme.palette.primary.main,
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main,
                    },
                },
                '& .MuiInputBase-input': {
                    color: theme.palette.text.primary,
                    py: 1.2,
                },
                ...sx,
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <MdSearch size={20} color={theme.palette.text.secondary} />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchField;